<template>
    <div>
        <ValidationObserver ref="formModalValidate">
           <b-row>
                <b-col cols="12" md="6">
                    <ValidationProvider name="student_club_id" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('club_name')">
                            <student-club-selectbox :validateError="errors[0]"
                                                 v-model="form.student_club_id"
                                                 @club-selected="handleClubSelection"
                                                 :state="errors[0] ? false : null">
                            </student-club-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
               <b-col cols="12" md="6">
                   <ValidationProvider name="role" rules="required" v-slot="{ valid, errors }">
                       <b-form-group :label="$t('role')">
                           <parameter-selectbox v-model="form.role"
                                                :validate-error="errors[0]" code="student_club_roles"></parameter-selectbox>
                       </b-form-group>
                   </ValidationProvider>
               </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="academic_year" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('academic_year')">
                            <academic-years-selectbox
                                v-model="form.academic_year"
                                :validate-error="errors[0]"
                                :activeYears="true"></academic-years-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="membership_date" rules="required" v-slot="{ valid, errors }">
						<b-form-group :label="$t('member_at')">
                            <select-date v-model="form.membership_date" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
						</b-form-group>
					</ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group :label="$t('student')">
                        <ValidationProvider name="user_id" rules="required" v-slot="{ errors }">
                            <students-auto-complete-by-key
                                :value="selectedPresident"
                                @user-input="handleSelection"
                                :validate-error="errors[0]" />
                        </ValidationProvider>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                   <ValidationProvider name="status" rules="" v-slot="{ errors }">
                       <b-form-group :label="$t('status')">
                           <parameter-selectbox v-model="form.status"
                                                :validate-error="errors[0]"
                                                code="student_club_student_statuses" />
                       </b-form-group>
                   </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="mobile_tel" rules="" v-slot="{valid, errors}">
                        <b-form-group :label="$t('mobile_number')">
                            <b-form-input
                                :placeholder="$t('mobile_placeholder')"
                                :state="errors[0] ? false : (valid ? true : null)"
                                v-model="form.mobile_tel" disabled></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                   <ValidationProvider name="email" rules="" v-slot="{valid, errors}">
                        <b-form-group :label="$t('email')">
                            <b-form-input
                                :placeholder="$t('email_placeholder')"
                                :state="errors[0] ? false : (valid ? true : null)"
                                v-model="form.email" disabled></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
               <b-col cols="12" md="6">
                   <ValidationProvider name="dues" rules="required" v-slot="{ valid, errors }">
                       <b-form-group :label="$t('fee')">
                           <b-form-input step="0.01" v-model="form.dues" disabled></b-form-input>
                           <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                       </b-form-group>
                   </ValidationProvider>
               </b-col>
            </b-row>
            <b-button
                @click="createForm"
                type="button"
                :disabled="formLoading"
                variant="primary"
                class="btn-lg mr-2"
            >
                {{ $t("save") | toUpperCase }}
            </b-button>
        </ValidationObserver>
    </div>
</template>

<script>
    //Component
    import ParameterSelectbox from "@/components/interactive-fields/ParameterSelectbox";

    //Other
    import {ValidationProvider, ValidationObserver} from "vee-validate"
    import moment from "moment";

    //Service
    import StudentClubMemberSearch from "@/services/StudentClubMemberSearch";
    import StudentClubSelectbox from "@/components/interactive-fields/StudentClubSelectbox.vue";
    import StudentsAutoCompleteByKey from "@/components/interactive-fields/StudentsAutoCompleteByKey"

    export default {
        components: {
            StudentsAutoCompleteByKey,
            StudentClubSelectbox,
            ValidationProvider, ValidationObserver,
            ParameterSelectbox,
        },
        data() {
            return {
                formLoading: false,
                selectedPresident: '',
                form: {
                    student_club_id: null,
                    role: [],
                    academic_year: null,
                    member_at: null,
                    user_id: null,
                    status: '',
                    mobile_tel: '',
                    email: '',
                    dues: null,
                    membership_date: moment().format("YYYY-MM-DD"),
                }
            }
        },
        methods: {
            async createForm() {
                const isValid = await this.$refs.formModalValidate.validate()
                if (isValid) {
                    this.formLoading = true;
                    StudentClubMemberSearch.store(this.form)
                                    .then((response) => {
                                        this.$toast.success(this.$t("api." + response.data.message));
                                        this.$emit("createFormSuccess")
                                    })
                                    .catch((error) => {
                                        this.showErrors(error, this.$refs.formModalValidate)
                                    }).finally(() => {
                        this.formLoading = false;
                    });
                }
            },
            handleSelection(user) {
                this.form.user_id = user?.user_id;
                this.selectedPresident = user ? `${user.student_number} ${user.name} ${user.surname}` : '';
                this.form.mobile_tel = user?.mobile_tel;
                this.form.email = user?.email;
            },
            handleClubSelection(clubData) {
                if (clubData && clubData.dues) {
                    this.form.dues = parseFloat(clubData.dues)
                } else {
                    this.form.dues = 0;
                }
            },
        }
    }
</script>
